import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { QuoteRepository } from '../../domain/quote/quote-repository';
import { QuoteRequest, QuoteResponse } from '../../domain/quote/quote-domain';
import { ApiUrlsService } from '@shared/constants/urls.contants';

@Injectable()
export class QuoteHttpRepository extends QuoteRepository {
  private readonly http = inject(HttpClient);
  private readonly urls = inject(ApiUrlsService);

  async createQuote(params: QuoteRequest): Promise<QuoteResponse> {
    return firstValueFrom(
      this.http.post<QuoteResponse>(this.urls.CREATE_QUOTE_URL, params)
    );
  }
}
